import React from 'react'; // Import React, which is necessary for creating the component
import { Link } from 'react-router-dom'; // Import 'Link' from 'react-router-dom' for internal navigation
import '../css/footer.css'; // Import the CSS file for styling the Footer component
// Define the Footer component
const UserFooter = () => {
    return (
        <div className="footer"> {/* The main container for the footer */}
            {/* Display a copyright notice */}
            <Link style={{color:'white'}} to ="/aboutus">About Us</Link>&nbsp;&nbsp;&nbsp;
            <Link style={{color:'white'}} to ="/contactus">Contact Us</Link>&nbsp;&nbsp;&nbsp;
            <Link style={{color:'white'}} to ="/services">Services</Link>
        </div>
    );
};

// Export the Footer component so it can be imported and used in other files
export default UserFooter;
